export default __webpack_public_path__ + "static/media/background.15c8260f.jpg";